import { NgModule } from '@angular/core';

import { OverviewClaimSpotButtonModule } from '@main-client/src/app/overview-claim-spot-button/overview-claim-spot-button.module';

import { OverviewClaimSpotComponent } from './overview-claim-spot.component';

@NgModule({
  declarations: [OverviewClaimSpotComponent],
  exports: [OverviewClaimSpotComponent],
  imports: [OverviewClaimSpotButtonModule],
})
export class OverviewClaimSpotModule {}
